import React from 'react';
import PureComponent from 'ROOT/src/components/pure';

import sAction from 'sAction';
import Button from 'ROOT/src/components/formElements/Button';
import DetailViewExportButtons from 'ROOT/views/portal/components/detailView/DetailViewExportButtons';

class DetailTitleComplain extends PureComponent {
    sendEmail = (email) => {
        const emailData = {
            to_addrs: email,
            account: 'portal_user',
            send_individually: true,
            disable_recipient_change: true,
            contact_form: true,
            complaint_form: true,
            loaded: true,
            parent_type: this.props.data.module,
            parent_id: this.props.data.id,
            parent_name: this.props.data.name,
        };

        sAction.openEmailPopup(emailData);
    };

    getEnquiryButton = (module) => {
        if (module === 'Quotes') {
            const email = sAction.dataGet(this.props.way + '/fields/obchodnik_email_c/value');
            return <Button className="roundedDetailAction"
                onClick={() => this.sendEmail(email)}>Dotaz k nabídce &nbsp; <span
                    className="mdi mdi-chevron-right"></span></Button>;
        } else {
            const email = sAction.dataGet(this.props.way + '/fields/email_email/value');
            return <Button className="roundedDetailAction"
                onClick={() => this.sendEmail(email)}>Dotaz k dokladu &nbsp; <span
                    className="mdi mdi-chevron-right"></span></Button>;
        }
    };

    render() {
        const data = this.props.data;

        return (
            <React.Fragment>
                <div className="header">
                    <div className="title">
                        <span className="detailViewName">
                            {sAction.translate('LBL_' + data.module.toUpperCase())}
                        </span>
                    </div>
                    <DetailViewExportButtons way={this.props.way} data={data}/>
                </div>
                <div className="divider"/>
                <div className="header">
                    <div className="title">
                        <span className="detailViewName2 red">
                            {sAction.decodeHTMLEntities(data.name)}
                        </span>
                        {this.getEnquiryButton(data.module)}
                    </div>
                </div>
                <br/>
            </React.Fragment>
        );
    }
}

export default DetailTitleComplain;
